<template>
  <div class="user-group-bar">
    <c-loading v-if="!ready" size="small" tip=""></c-loading>
    <template v-else>
      <div class="row" v-show="!active" @click="active = true">
        <label>分析用户群：</label>
        <template v-for="group in showResult">
          <span
            v-if="group.id > -1"
            class="group-label"
            :key="'label' + group.id"
          >
            <i class="icon-user"></i>{{ group.name }}
          </span>
        </template>
        <i class="cicon-pulldown"></i>
      </div>

      <div class="row active" v-show="active">
        <label>分析用户群：</label>

        <span class="group" v-for="id in result" :key="id">
          <user-group-selector
            :key="'group' + id"
            v-model="resultMap[id]">
          </user-group-selector>
          <i
            class="cicon-remove"
            v-if="result.length > 1"
            @click="onDelGroup(id)"
          ></i>
        </span>

        <span class="add-group" @click="addGroup" v-if="result.length < max">
          <i class="cicon-add"></i>添加用户群做对比
        </span>

        <div class="to-button">
          <zg-button type="primary" @click="onClickOk" size="normal">
            确定
          </zg-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { util } from '../../utils'
import UserGroupSelector from './userGroupSelector'
export default {
  name: 'userGroupBar',
  components: {
    UserGroupSelector
  },
  props: {
    value: {
      type: Array,
      default () {
        return [
          {
            id: 0 // 默认选中所有用户
          }
        ]
      }
    },
    max: {
      type: Number,
      default: 3
    }
  },
  data () {
    let data = {
      active: false,
      result: [], // 为了保证用户群的顺序
      resultMap: {}, // resultMap才是真正绑定用户群信息的对象
      haveInit: false
    }
    return data
  },
  computed: {
    ...mapState({
      groupList (state) {
        return [
          {
            id: -1,
            name:  `新建用户群`,
            children: state.bizUserGroup.list
          }
        ]
      },
      ready (state) {
        const ready = state.bizUserGroup.ready.list
        return ready
      }
    }),
    /**
     * @description 用于文本显示的结果列表
     */
    showResult () {
      let result = []
      this.result.forEach(id => {
        let group = this.resultMap[id]
        if (group) result.push(group)
      })
      if (!result.length) result.push({ id: 0, name: '所有用户' })
      // if (!this.active && this.ready) this.$emit('input', result) // 为了解决初始化状态，同步value值，确定按钮去掉的话，该处理也应去掉
      return result
    }
  },
  watch: {
    max (count) {
      // count发生变化后，把超出的用户群取消选择
      this.showResult.forEach((group, i) => {
        if (i >= count) {
          let id = this.result.find(id => {
            return this.resultMap[id].id === group.id
          })
          this.onDelGroup(id)
        }
      })
      this.onClickOk()
    },
    ready (ready) {
      if (ready) {
        this.initValue()
      }
    }
  },
  beforeMount () {
    if (this.ready) {
      this.initValue()
    }
  },
  methods: {
    initValue () {
      if (this.haveInit) return
      this.result = []
      this.resultMap = {}
      let groups = this.value.length ? this.value : [{ id: 0 }]
      groups.forEach(_group => {
        if (_group) {
          let group = this.groupList[0].children.filter(item => {
            return item.id === parseInt(_group.id)
          })[0]
          let id = util.guid()
          this.result.push(id)
          this.resultMap[id] = group
        }
      })
      // this.onClickOk()
      this.haveInit = true
    },
    onClickOk () {
      // 校验用户群
      if (!this.valid()) return
      // 过滤空数据
      this.result = this.result.filter(id => {
        let group = this.resultMap[id]
        if (!group) delete this.resultMap[id]
        return group
      })
      this.active = false
      this.$emit('input', this.showResult)
      this.$emit('clickOk')
    },
    addGroup () {
      let id = util.guid()
      this.result.push(id)
      this.$set(this.resultMap, id, {
        id: -1
      })
    },
    onDelGroup (id) {
      if (this.result.length === 1) {
        this.$set(this.resultMap, id, {
          id: 0
        })
        return
      }
      this.result.forEach((item, i) => {
        if (item === id) this.result.splice(i, 1)
      })
      delete this.resultMap[id]
    },
    valid () {
      let ids = []
      let valid = true
      for (let i = 0; i < this.result.length; i++) {
        let id = this.result[i]
        let group = this.resultMap[id]
        if (group) {
          if (ids.length > 0 && ids.includes(group.id)) {
            valid = false
            this.$message({
              type: 'error',
              message: '用户群选择不能重复'
            })
            break
          }
          ids.push(group.id)
        }
      }
      return valid
    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
